import { useEffect } from 'react';
import { useAuth } from '../context/Context';

/**
 * Applies site branding (favicon + document title) once site settings load.
 *
 * The Admin Panel Maintenance redirect used to live here too. It moved to the
 * MaintenanceGate route guard in App.js: redirecting from an effect only ran
 * after the tree had committed, so the dashboard painted and fired its API
 * calls before being swapped out, and the URL was rewritten to /maintenance.
 * A guard renders the maintenance screen in place, on whatever path was asked
 * for, and nothing behind it ever mounts.
 */
const SiteDataLoader = () => {
        const { siteData } = useAuth();

    useEffect(() => {
                if (!siteData) return;

                let link = document.querySelector("link[rel~='icon']");
                if (!link) {
                        link = document.createElement("link");
                        link.rel = "icon";
                        document.head.appendChild(link);
                }
                if (siteData?.favicon) {
                        link.href = siteData.favicon;
                }
                document.title = siteData?.title ?? 'HikeCinema Admin';
        }, [siteData]);

        return null;
};

export default SiteDataLoader;
